import * as THREE from 'three';
import { Enemy } from '../enemies/Enemy';

/**
 * Types of traps available in the game
 */
export enum TrapType {
  SPIKE = 0,
  FIRE = 1,
  ICE = 2,
  POISON = 3
}

/**
 * Interface for trap objects
 */
export interface Trap {
  /** The type of trap */
  type: TrapType;
  
  /** The 3D mesh representing the trap */
  mesh: THREE.Mesh;
  
  /** The position of the trap */
  position: THREE.Vector3;
  
  /** Whether the trap is currently active */
  active: boolean;
  
  /** Cooldown time remaining before the trap can be triggered again */
  cooldown: number;
  
  /** Base damage of the trap */
  damage: number;
  
  /** Radius of effect */
  radius: number;
  
  /** Duration of effect in seconds */
  duration: number;
  
  /** Strength of the trap's effect (0-1) */
  effectStrength: number;
  
  /** Time when the trap was triggered (in seconds since page load) */
  triggeredTime: number;
  
  /** Set of enemy IDs that have been affected by this trap */
  affectedEnemies: Set<string>;
}

/**
 * Cost of each trap type in resources
 */
export const TRAP_COSTS: Record<TrapType, number> = {
  [TrapType.SPIKE]: 50,
  [TrapType.FIRE]: 75,
  [TrapType.ICE]: 100,
  [TrapType.POISON]: 125
};

/**
 * Names of each trap type
 */
export const TRAP_NAMES: Record<TrapType, string> = {
  [TrapType.SPIKE]: "Spike Trap",
  [TrapType.FIRE]: "Fire Trap",
  [TrapType.ICE]: "Ice Trap",
  [TrapType.POISON]: "Poison Trap"
};

/**
 * Descriptions of each trap type
 */
export const TRAP_DESCRIPTIONS: Record<TrapType, string> = {
  [TrapType.SPIKE]: "Deals high instant damage to enemies",
  [TrapType.FIRE]: "Deals damage over time to enemies in an area",
  [TrapType.ICE]: "Slows enemies and deals minor damage",
  [TrapType.POISON]: "Poisons enemies, dealing damage over time"
}; 